import { useTranslation } from 'react-i18next'

import { ErrorView } from '../ErrorView'

interface PageNotFoundProps {
  redirectUrl?: string
  showLogo?: boolean
}

export function PageNotFound({ redirectUrl = '/account/activity', showLogo = false }: PageNotFoundProps) {
  const { t } = useTranslation()

  return (
    <ErrorView
      showLogo={showLogo}
      buttonText={t('Go to activity', { context: 'Title of the button on the 404 page' })}
      titleText={t('Page not found', { context: 'Title of the 404 page' })}
      secondaryText={t('An error occurred and the Cash App team has been notified.', {
        context: 'Message on the 404 page',
      })}
      redirectUrl={redirectUrl}
      useAnimation={true}
      renderContainer={false}
      renderStatusPageButton={false}
    />
  )
}

export default PageNotFound
